import { Flex, Text, Box, Image } from "@chakra-ui/react"
import divider from '../assets/images/icon.png'

const About = () => {
  return (
   <>
   <Flex w="100%" justify="center" mt={8} px={8} mb={8}>
        <Box
          flex="1"
          p={4}
          mx={0}
          textAlign="center"
          fontSize={{ base: 24, lg: 40 }}
          display="flex" // Use flexbox on the Box
          flexDirection="column" // Column direction to stack the image and text
          alignItems="center" // Center items horizontally
        >
          <Text mb={14}>Discover What Makes Us Different</Text>
          <Image src={divider} width="50px" />
        </Box>
      </Flex>
   
   </>
  );
}


export default About;